const styles = theme => ({
    headerLi: {
        listStyle: 'none',
        fontSize: 14,
        fontWeight: 600,
        color: theme.palette.header.contrastText,
        marginLeft: -8,
        marginRight: -8
    },

    active: {
        color: `${theme.palette.primary.main} !important`,
        borderBottom: `solid 8px ${theme.palette.primary.main}`,        
    },
    anchor: {
        color: theme.palette.header.contrastText,
        marginRight: theme.spacing(2),
        textDecoration: 'none',
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 11,
        fontWeight: 400,
        '&:hover': {
            textDecoration: 'none',
            color: `${theme.palette.primary.main} !important`,
        }
    }
});

export default styles;